import PendoButton from '../../../components/button/pendo-button.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import PendoDivider from '../../../components/divider/pendo-divider.vue.js';
import PendoGuideElementTypeAction from '../guide-elements-table/guide-element-type-action/pendo-guide-element-type-action.vue.js';
import get from 'lodash/get.js';

var script = {
  name: 'PendoGuideElementsDrawerHeader',
  components: {
    PendoGuideElementTypeAction,
    PendoButton,
    PendoDivider
  },
  directives: {
    PendoTooltip
  },
  props: {
    uiElement: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      overflowTooltipContent: this.uiElement.uiElementText
    };
  },
  computed: {
    uiElementType() {
      const typeArray = [];
      if (this.uiElement.uiElementType) {
        typeArray.push({
          name: this.uiElement.uiElementType,
          icon: this.uiElement.uiElementTypeIcon
        });
      }
      return typeArray;
    },
    uiElementActions() {
      return get(this.uiElement, 'uiElementActions', []).map(action => {
        return {
          name: action.action,
          icon: action.icon
        };
      });
    }
  },
  methods: {
    checkForOverflowingContent(event, tooltipText) {
      const {
        scrollWidth,
        clientWidth
      } = event.target;
      this.overflowTooltipContent = scrollWidth > clientWidth ? tooltipText : null;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-elements-drawer-header.vue2.js.map
